import { render } from "./ChartReports.vue?vue&type=template&id=596644b3"
import script from "./ChartReports.vue?vue&type=script&lang=js"
export * from "./ChartReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__